@if (!(isAuthenticated$ | async)) {
  <div class="flex flex-col bg-background h-screen overflow-hidden">
    <div
      class="container flex grow items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0 overflow-hidden"
    >
      <div class="hidden lg:flex h-full flex-col items-center justify-between bg-[#1071EF] overflow-hidden">
        <!-- SVG Top -->
        <svg
          width="80%"
          height="30%"
          viewBox="0 0 500 302"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="opacity-20"
        >
          <path
            d="M114.172 45.0002L0.150424 76.4085C0.150424 76.4085 -0.451272 139.727 0.752119 195.92C0.150424 243.221 26.9259 285.83 56.9103 298.173C66.0361 301.886 74.5601 302.187 82.2818 299.678C93.0121 296.166 101.937 286.934 107.553 273.387C111.865 263.052 114.372 250.308 114.372 235.657L114.372 45.0002H114.172Z"
            fill="url(#paint0_linear_top)"
          />
          <path
            d="M114.815 -656.409L114.815 235.65C114.815 250.301 112.308 263.045 107.995 273.38C102.38 286.927 93.4544 296.058 82.7242 299.671L463.999 177.851C484.958 172.031 499.499 149.754 500 114.432L500 -741L114.815 -656.409Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_top"
              x1="57.1861"
              y1="45.0002"
              x2="114.667"
              y2="292.834"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.555" />
              <stop offset="0.8" />
              <stop offset="1" />
            </linearGradient>
          </defs>
        </svg>

        <app-rive />

        <!-- SVG Bottom -->
        <svg
          width="80%"
          height="30%"
          viewBox="0 0 500 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="opacity-20"
        >
          <path
            d="M385.829 257.001L499.85 225.593C499.85 225.593 500.452 162.275 499.248 106.081C499.85 58.7806 473.075 16.1712 443.09 3.82865C433.964 0.115869 425.44 -0.185187 417.719 2.32346C406.988 5.83556 398.063 15.0674 392.447 28.6141C388.135 38.9497 385.628 51.6936 385.628 66.3441L385.628 257.001L385.829 257.001Z"
            fill="url(#paint0_linear_bottom)"
          />
          <path
            d="M385.185 958.409L385.186 66.35C385.186 51.6995 387.693 38.9557 392.005 28.6201C397.621 15.0735 406.546 5.94189 417.276 2.32947L36.0018 124.149C15.0428 129.969 0.501817 152.246 0.000410478 187.568L0.000335693 1043L385.185 958.409Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_bottom"
              x1="442.814"
              y1="257.001"
              x2="385.334"
              y2="9.16765"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.555" />
              <stop offset="0.8" />
              <stop offset="1" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="flex h-full items-center justify-center">
        <div class="flex flex-col items-center gap-8 lg:p-8 w-full">
          <img src="assets/logo-small.png" alt="Pagai Logo" class="w-16" />

          <div class="flex w-full items-center justify-center">
            @if (state() === authenticateState.SIGN_IN) {
              <app-sign-in (signInEvent)="changeAuthState($event)" />
            } @else if (state() === authenticateState.SIGN_UP) {
              <app-sign-up (signUpEvent)="changeAuthState($event)" />
            } @else if (state() === authenticateState.CONFIRM_SIGN_UP) {
              <app-confirm-sign-up (confirmSignUpEvent)="changeAuthState($event)" />
            } @else if (state() === authenticateState.FORGOT_PASSWORD) {
              <app-forgot-password (forgotPasswordEvent)="changeAuthState($event)" />
            } @else if (state() === authenticateState.RESET_PASSWORD) {
              <app-reset-password (resetPasswordEvent)="changeAuthState($event)" />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <ng-container [ngTemplateOutlet]="authContent?.templateRef ?? null"></ng-container>
}
